import { useState, useCallback } from 'react';
import auditService, { MostRecentAuditResponse } from '../services/auditService';

export const usePreviousAuditData = () => {
  const [previousAuditData, setPreviousAuditData] = useState<MostRecentAuditResponse | null>(null);
  const [comparisonLoading, setComparisonLoading] = useState(false);

  const loadPreviousAuditData = useCallback(async (
    currentStoreId: string,
    currentShiftDate: string,
    currentShiftTime: string
  ): Promise<MostRecentAuditResponse | null> => {
    if (!currentStoreId || !currentShiftDate || !currentShiftTime) {
      return null;
    }

    try {
      setComparisonLoading(true);

      const [startTime, endTime] = currentShiftTime.split(' TO ');
      const [mm, dd, yy] = currentShiftDate.split('/');
      const yyyy = Number(yy) < 50 ? '20' + yy : '19' + yy;
      const isoDate = `${yyyy}-${mm.padStart(2, '0')}-${dd.padStart(2, '0')}`;

      let isoDateTime;
      const timeCandidate = (endTime && endTime.trim()) || (startTime && startTime.trim()) || '';

      if (timeCandidate && timeCandidate.includes(':')) {
        const [hours, minutes] = timeCandidate.split(':');
        const validHours = Math.min(Math.max(parseInt(hours) || 0, 0), 23);
        const validMinutes = Math.min(Math.max(parseInt(minutes) || 0, 0), 59);
        const formattedTime = `${validHours.toString().padStart(2, '0')}:${validMinutes.toString().padStart(2, '0')}:00`;
        isoDateTime = new Date(`${isoDate}T${formattedTime}Z`).toISOString();
      } else {
        isoDateTime = new Date(`${isoDate}T00:00:00`).toISOString();
      }

      const previousData = await auditService.getMostRecentAuditDetails(currentStoreId, isoDateTime);
      setPreviousAuditData(previousData);

      return previousData;
    } catch (err: any) {
      console.log('No previous audit data found:', err);
      return null;
    } finally {
      setComparisonLoading(false);
    }
  }, []);

  return {
    previousAuditData,
    comparisonLoading,
    loadPreviousAuditData,
  };
};

